<template>
  <div>
    <div
      class="row rowOpenvidu"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'openvidu'
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="subscriber"></div>
      </div>
    </div>
    <div
      class="row rowAnt"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ant' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video id="remoteVideo" autoplay controls playsinline></video>
      </div>
    </div>
    <div
      class="row rowFlash"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'sh' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <div id="playFlash">
          <video id="flashPlayVideo" controls="controls"></video>
        </div>
      </div>
    </div>
    <div
      v-if="retornaSite() !== '7live'"
      class="row rowMS"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="msPlayVideo"
          autoplay
          controls
          playsinline
          style="display: none"
          :muted="audioMudo"
        ></video>
      </div>
    </div>
    <div
      v-if="retornaSite() !== '7live'"
      class="row rowMS"
      v-bind:style="{
        display:
          options.replay && item.evento && item.evento.servidorTipo == 'ms'
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <video
          id="msPlayVideoBackup"
          autoplay
          controls
          playsinline
          :muted="audioMudo"
        ></video>
      </div>
    </div>
    <div
      v-if="retornaSite() == '7live'"
      id="frameVideo"
      style="position: relative"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' ? 'block' : 'none',
      }"
    >
      <video
        id="msPlayVideo"
        autoplay
        controls
        playsinline
        style="display: none; height: 100%; max-height: 100%"
        :muted="audioMudo"
      ></video>
    </div>
    <div
      class="row rowFuncoes"
      v-bind:style="{
        display:
          item.evento && item.evento.servidorTipo == 'ms' && false == true
            ? 'block'
            : 'none',
      }"
    >
      <div class="col-md-12 text-center" style="padding: 0">
        <button @click="fullScreen()">Tela Cheia</button>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="
          propSofaScore &&
          item.evento &&
          (item.evento.sofaScoreId || item.evento.williamHillId)
        "
      >
        <div
          v-if="item.evento.sofaScoreId && options.sofascore"
          style="height: 86px"
        >
          <iframe
            width="100%"
            height="86"
            frameborder="0"
            scrolling="no"
            :src="'/sofascore/' + item.evento.sofaScoreId"
          ></iframe>
        </div>
        <div v-if="item.evento.williamHillId && options.williamhill">
          <iframe
            width="100%"
            height="330"
            frameborder="0"
            scrolling="no"
            :src="
              'https://score.kwddw.com/scoreboards/app/football/index.html?eventId=' +
              william(item.evento.williamHillId) +
              '&sport=football&locale=pt-pt'
            "
          ></iframe>
        </div>
      </div>
    </div>
    <div class="row" v-if="!item.erro">
      <div
        class="col-md-12 text-center"
        style="padding: 0"
        v-if="propSofaScore && item.evento && item.evento.sofaScore"
      >
        <div v-html="item.evento.sofaScore"></div>
      </div>
    </div>
    <div class="row" v-if="item.erro">
      <div class="col-md-12 text-center" style="margin-top: 40px">
        <h5 style="color: white">{{ item.erroMensagem }}</h5>
      </div>
    </div>
    <i
      v-if="retornaSite() == '7live'"
      class="d234fdsa2"
      :style="{ top: markTop + 'px' }"
      >{{ markText }}</i
    >

    <div class="card settings-menu p-1" style="width: 18rem" v-if="menuOpen">
      <div class="card-body text-center">
        <h5 class="card-title text-center">Opções</h5>
        <div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-warning btn-sm"
              style="margin-right: 5px"
              @click="options.sofascore = !options.sofascore"
            >
              {{ options.sofascore == true ? "Sim" : "Nao" }}
            </button>
            <label
              class="form-check-label"
              style="margin-top: 4px; min-width: 75px"
              >Sofascore</label
            >
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              class="btn btn-warning btn-sm"
              style="margin-right: 5px"
              @click="options.williamhill = !options.williamhill"
            >
              {{ options.williamhill == true ? "Sim" : "Nao" }}
            </button>
            <label
              class="form-check-label"
              style="margin-top: 4px; min-width: 75px"
              >Williamhill</label
            >
          </div>
          <div class="form-check" v-if="false">
            <input
              class="form-check-input"
              type="checkbox"
              v-model="options.replay"
              id="replay"
              @click="goReplay"
            />
            <label class="form-check-label" for="replay">Replay</label>
          </div>
        </div>
        <div class="mt-2">
          <a @click="menuOpen = false" class="card-link" style="cursor: pointer"
            >Fechar</a
          >
        </div>
      </div>
    </div>

    <div class="footer-wrapper" v-if="!menuOpen">
      <button
        class="btn btn-secondary footer-button"
        @click="toggleMenu"
        v-if="retornaSite() == 'Weddbets' || retornaSite() == 'Bll'"
      >
        Opções
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import { apiOpenVidu } from "@/services/apiOpenVidu.js";
import { apiAnt } from "@/services/apiAnt.js";
import { apiFlashphoner } from "@/services/apiFlashphoner.js";
import { apiMS } from "@/services/apiMS.js";
import util from "../includes/util.js";

let canvas_in;
let canvas_out;

let delay = 5;
let buffer = [];

export default {
  name: "ViewEvento",
  components: {},
  props: {
    propSofaScore: { type: Boolean, default: true },
  },
  data: function () {
    return {
      item: {
        evento: null,
        erro: false,
        token: "",
        erroMensagem: "",
      },
      lastWk: "",
      viewEventoOpen: {},
      menuOpen: false,
      options: {
        sofascore: false,
        williamhill: false,
        replay: false,
      },
      replayLoad: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
    },
    retornaSite() {
      return this.$site;
    },
    async carregarItem1(id) {
      console.log(id);
    },
    async carregarItem(id) {
      var parametros = "";

      if (this.$route.query.canal) {
        parametros = "?canal=" + this.$route.query.canal;
      }

      const response = await api.get("/evento/view/" + id + parametros);

      //* Verifica se econtrou
      if (response.data.erro == false && response.data.itens.length > 0) {
        this.viewEventoOpen = response.data.itens[0];

        let tituloEventoPre = "";

        if (
          this.$sessao.usuario.tipoUsuario == "Administrador" ||
          this.$sessao.usuario.tipoUsuario == "Apresentador"
        ) {
          if (
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataHora"
            ) &&
            Object.prototype.hasOwnProperty.call(
              this.viewEventoOpen,
              "dataMinuto"
            )
          ) {
            tituloEventoPre =
              this.viewEventoOpen.dataHora.toString().padStart(2, "0") +
              ":" +
              this.viewEventoOpen.dataMinuto.toString().padStart(2, "0") +
              " - ";
          }
        }

        if (this.$route.query.canal) {
          document.title =
            "(" +
            this.$route.query.canal +
            ") " +
            tituloEventoPre +
            this.viewEventoOpen.nome;
        } else {
          document.title = tituloEventoPre + this.viewEventoOpen.nome;
        }

        this.item.evento = this.viewEventoOpen;
        this.item.evento.servidorTipo = this.item.evento.servidorTipo
          ? this.item.evento.servidorTipo
          : "openvidu";
        this.item.erro = false;

        if (this.item.evento.servidorTipo == "openvidu") {
          apiOpenVidu.entrarSessaoB(this.viewEventoOpen);
        } else if (this.item.evento.servidorTipo == "ant") {
          apiAnt.view(this.item.evento);
        } else if (this.item.evento.servidorTipo == "sh") {
          apiFlashphoner.initStream();
          apiFlashphoner.connectPlay(
            this.viewEventoOpen.key,
            this.item.evento,
            this.item.evento.canal
          );
        } else if (this.item.evento.servidorTipo == "ms") {
          apiMS.setUrl(this.item.evento.servidor);
          apiMS.setToken(this.item.evento.msToken);

          await apiMS.connect({ subscribe: true });
        }
      } else {
        this.item.erro = true;
        this.item.erroMensagem = response.data.mensagem;
      }
    },
    async sessionView() {
      var body = {
        token: this.viewEventoOpen.sessaoView,
      };

      try {
        await api.put("/sessaoView", body);
      } catch (error) {
        console.log(error);
      }
    },
    william(id) {
      return id.replace("OB_EV", "");
    },
    getView() {
      if (
        (this.$route.query.view && this.$route.query.view == "clean") ||
        this.$site == "7live"
      ) {
        return false;
      }

      return true;
    },
    apiFlashphoner() {
      return apiFlashphoner;
    },
    fullScreen() {
      if (!document.fullscreenElement) {
        document.getElementById("frameVideo").requestFullscreen();
      } else if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    },
    createWatermark() {
      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        const watermark = document.createElement("div");
        watermark.innerHTML =
          this.$sessao.usuario.site + "<br />" + this.$sessao.usuario.email;

        watermark.className = this.lastWk;
        watermark.style.position = "absolute";
        watermark.style.color = "rgba(218, 165, 255, 0.5)";
        watermark.style.backgroundColor = "rgba(0, 0, 0, 0.0)";
        watermark.style.padding = "5px 10px";
        watermark.style.borderRadius = "5px";
        watermark.style.pointerEvents = "none";
        watermark.style.zIndex = "10";
        watermark.style.fontSize = "10px";
        watermark.style.fontWeight = "bold";

        const x = Math.random() * (videoContainer.clientWidth - 164);
        const y = Math.random() * (videoContainer.clientHeight - 40);

        watermark.style.left = `${x}px`;
        watermark.style.top = `${y}px`;

        videoContainer.appendChild(watermark);
      }
    },
    ensureWatermark() {
      if (this.lastWk !== "") {
        const watermarks = document.querySelectorAll("." + this.lastWk);

        // Remove cada elemento selecionado
        watermarks.forEach((watermark) => {
          watermark.remove();
        });
      }

      this.lastWk = util.guidGenerator().replace(/[^a-zA-Z]/g, "");

      const videoContainer = document.getElementById("msPlayVideo").parentNode;

      if (videoContainer) {
        this.createWatermark();
      }
    },
    criarCanvas() {
      canvas_in = document.createElement("canvas");
      //canvas_in.width = "100%";
      canvas_in.width = 640;
      canvas_in.height = 360;
      canvas_in.style.position = "absolute";
      canvas_in.style.left = "-9999px";
      canvas_in.id = "canvas_in";
      document.body.appendChild(canvas_in);

      canvas_out = document.createElement("canvas");
      canvas_out.width = 640;
      canvas_out.height = 360;
      canvas_out.style.position = "absolute";
      canvas_out.style.left = "-9999px";
      canvas_out.id = "canvas_out";
      document.body.appendChild(canvas_out);
    },
    goReplay() {
      if (this.replayLoad == false) {
        this.replayLoad = true;

        this.criarCanvas();

        //* Carrega conteudo do video e desenha no canvas
        //const originalVideo = document.getElementById("msPlayVideo");

        /*let thisCall;

        originalVideo.oncanplay = function () {
          thisCall.goReplay();
        };*/

        //* Exemplo carrega do canvas e coloca em player
        let msPlayVideoBackup = document.getElementById("msPlayVideoBackup");
        //let canvas_out = document.getElementById("canvas_in");
        const stream = canvas_out.captureStream(30);
        msPlayVideoBackup.srcObject = stream;
      }

      let video = document.getElementById("msPlayVideo");
      //let canvas_in = document.getElementById("canvas_in");
      //let canvas_out = document.getElementById("canvas_out");

      let now = Date.now();
      let context = canvas_in.getContext("2d");

      // Set sizes of elements
      let width = video.videoWidth,
        height = video.videoHeight;
      let width_want = canvas_in.clientWidth;
      height *= width_want / width;
      width = width_want;

      canvas_in.width = width;
      canvas_in.height = height;
      canvas_out.width = width;
      canvas_out.height = height;

      //* Inverte a imagem
      //context.scale(-1, 1);
      //context.drawImage(video, 0, 0, -width, height);
      context.scale(1, 1);
      context.drawImage(video, 0, 0, width, height);

      //* Teste texto
      /*context.font = "bold 30px Arial";
context.fillStyle = "rgba(255, 255, 255, 0.8)"; // Cor branca com transparência
context.fillText("Live Streaming", 20, 50);*/

      //* Copia o buffer
      let data = context.getImageData(0, 0, width, height);
      buffer.push([now, data]);

      while (buffer.length >= 2 && buffer[0][0] < now - delay * 1000)
        buffer.shift();

      let context2 = canvas_out.getContext("2d");
      context2.putImageData(buffer[0][1], 0, 0);

      //* Atualiza novamente
      window.setTimeout(this.goReplay, 20);
    },
  },
  mounted() {
    //var thisCall = this;

    document.body.style.backgroundColor = "black";
    document.body.style.overflow = "hidden";
    document.getElementById("app").style["margin-top"] = "0";
    this.carregarItem(this.$route.params.id);
    document.addEventListener("contextmenu", function (e) {
      e.preventDefault();
    });

    if (this.$route.query.view && this.$route.query.view == "clean") {
      this.options.williamhill = false;
      this.options.sofascore = false;
    } else {
      this.options.williamhill = true;
      this.options.sofascore = true;
    }

    setInterval(() => {
      this.sessionView();
    }, 15000);

    /*setInterval(function () {
      thisCall.ensureWatermark();
    }, 10000);*/

    this.markText = this.$sessao.usuario.email;
  },
  computed: {
    audioMudo: function () {
      return (
        this.$sessao.usuario.tipoUsuario == "Administrador" ||
        this.$sessao.usuario.tipoUsuario == "Apresentador"
      );
    },
  },
};
</script>

<style>
.settings-btn {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: transparent;
  border: none;
  outline: none;
}

.settings-btn i {
  font-size: 30px;
  color: gray;
}

.settings-btn svg {
  width: 20px;
  height: 20px;
  fill: gray;
}

.settings-menu {
  position: fixed;
  bottom: 70px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px;
  border-radius: 5px;
}

.footer-wrapper {
  position: fixed;
  top: 0;
  width: 97%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.footer-button {
  opacity: 0;
  transition: opacity 0.3s ease;
  margin-top: 10px;
  pointer-events: none;
}

.footer-wrapper:hover .footer-button {
  opacity: 1;
  pointer-events: auto;
}

.d234fdsa1 {
  position: relative;
  left: 3%;
  top: 3%;
  color: white;
  animation: 30s d9df922f0d1 infinite;
}

.d234fdsa2 {
  position: absolute;
  color: white;
  animation: 60s d9df922f0d1 infinite;
  opacity: 0.5;
}

/* center */
.d234fdsa3 {
  position: fixed;
  top: 5%;
  left: 50%;
  color: white;
  animation: 60s d9df922f0d12 infinite;
  opacity: 0.6;
  transform: translate(-50%, -50%);
}

@keyframes d9df922f0d1 {
  0% {
    left: 3px;
    opacity: 0.5;
  }

  25% {
    opacity: 0;
  }

  50% {
    right: 3px;
    opacity: 0.5;
  }

  75% {
    opacity: 0;
  }
}

@keyframes d9df922f0d {
  0% {
    left: 3%;
    top: 3%;
  }

  25% {
    left: 87%;
    top: 3%;
  }

  50% {
    left: 87%;
    top: 87%;
  }

  75% {
    left: 3%;
    top: 87%;
  }

  100% {
    left: 3%;
    top: 3%;
  }
}
</style>
